var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4S(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 112,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 112,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    d: "M7.21 24.698h5.46V28h2.86v-3.302h1.352v-2.6H15.53V9.8h-3.12l-5.2 12.298v2.6Zm2.626-2.6 2.782-6.734h.052v6.734H9.836Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    fillRule: "evenodd",
    d: "M7.553 42.266c-1.182 1.312-1.182 3.439 0 4.75.882.978 2.172 1.227 3.262.747v2.904h2.37v-2.904c1.09.48 2.38.231 3.262-.747 1.182-1.311 1.182-3.438 0-4.75L12 37.333l-4.447 4.933ZM33.33 53.4c-1.773 1.967-1.773 5.157 0 7.124 1.323 1.468 3.258 1.84 4.892 1.12V66h3.556v-4.356c1.634.72 3.57.348 4.892-1.12 1.773-1.967 1.773-5.157 0-7.125L40 46l-6.67 7.4Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    d: "M72.79 87.302h-5.46V84h-2.86v3.302h-1.352v2.6h1.352V102.2h3.12l5.2-12.298v-2.6Zm-2.626 2.6-2.782 6.734h-.052v-6.734h2.834Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    fillRule: "evenodd",
    d: "M72.447 69.734c1.182-1.312 1.182-3.439 0-4.75-.882-.978-2.172-1.227-3.262-.746v-2.905h-2.37v2.904c-1.09-.48-2.38-.231-3.262.747-1.182 1.311-1.182 3.438 0 4.75L68 74.667l4.447-4.933Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4S);
export default __webpack_public_path__ + "static/media/4S.c62b0728034b8a6b28ccd9e20d99feda.svg";
export { ForwardRef as ReactComponent };